import React from 'react';

const configContext = React.createContext({
  config: {},
});

export default configContext;
